import { Reducer } from "redux";

import { PostReAuthRequestActionDispatchTypes } from "../models/dispatchTypes/Referral";
import {
  PostReAuthRequestDispatchTypes,
} from "../constants/Referral";
import { PostReAuthRequestResponse } from "../models/api/Referral";

const initialState: PostReAuthRequestResponse = {
  loading: false,
  response: {
    requestId: "",
    referralId: 0,
    status: "",
    dateCompleted: "",
    serviceRequestId: 0,
    memberName: "",
    userNameCreated: "",
  },
  error: null,
};

const PostReAuthReducer: Reducer<
  PostReAuthRequestResponse,
  PostReAuthRequestActionDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case PostReAuthRequestDispatchTypes.POST_RE_AUTH_REQUEST_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case PostReAuthRequestDispatchTypes.POST_RE_AUTH_REQUEST_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case PostReAuthRequestDispatchTypes.POST_RE_AUTH_REQUEST_ERRORS: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case PostReAuthRequestDispatchTypes.POST_RE_AUTH_REQUEST_RESET: {
      return initialState;
    }
  }
  return state;
};

export default PostReAuthReducer;
